import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { VerifyTermApi } from "../../../../../../../../../services/Api/Organization/organizationTypes";
import {
	SubscriptionInvoiceApi,
	SubscriptionVisibility,
	SubscriptionsApi,
} from "../../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { selectOrganization } from "../../../../../../../../../services/organizations/selectors";
import SubscriptionTotalPrice from "../SubscriptionTotalPrice";
import { areAllSubscriptionsCancelled } from "../utils";

interface Props {
	subscriptions: SubscriptionsApi;
	unpaidProformas: SubscriptionInvoiceApi[];
	subscriptionsVisibility: SubscriptionVisibility;
	termsToAccept: VerifyTermApi[];
}

const SubscriptionPreviewSummaryCard = ({
	subscriptions,
	unpaidProformas,
	subscriptionsVisibility,
	termsToAccept,
}: Props) => {
	const { t } = useTranslation();
	const blockedUnpaidProformas = unpaidProformas.filter((proforma) => proforma.blocked);
	const organization = useSelector(selectOrganization);

	return (
		<Card style={{ backgroundColor: "#F8F9FA", borderColor: "#F8F9FA" }}>
			<Card.Body>
				<h5 className="mb-2">{t("lib:common.word.summary")}</h5>
				<div className="subscriptions-summary mb-3">
					<h6>{t("modules.subscription.field.price_net.title")}</h6>
					<div className="d-flex flex-column align-items-end">
						<SubscriptionTotalPrice totals={subscriptions.totals} />
					</div>
				</div>
				{blockedUnpaidProformas.length > 0 && (
					<span className="text-danger">
						{t("modules.subscription.field.unpaid_proformas_description.title")}
					</span>
				)}
				{blockedUnpaidProformas.length === 0 &&
					subscriptionsVisibility === SubscriptionVisibility.VISIBLE &&
					termsToAccept.length === 0 &&
					subscriptions.customer.status === "ACTIVE" && (
						<Link className="btn btn-primary w-100" to={`/${organization.id}/subscriptions/edit`}>
							{areAllSubscriptionsCancelled(subscriptions.subscriptions)
								? t("lib:common.action.activate")
								: t("modules.subscription.action.change_subscription.title")}
						</Link>
					)}
				{blockedUnpaidProformas.length === 0 &&
					subscriptionsVisibility === SubscriptionVisibility.VISIBLE &&
					termsToAccept.length === 0 &&
					subscriptions.customer.status === "NEW" && (
						<Link className="btn btn-primary w-100" to={`/${organization.id}/subscriptions/edit`}>
							{t("modules.subscription.action.activate_subscription.title")}
						</Link>
					)}
			</Card.Body>
		</Card>
	);
};

export default SubscriptionPreviewSummaryCard;
